import { Form, Formik, useFormik } from "formik";
import { LegacyRef } from "react";
import { useTranslation } from "react-i18next";
import { InitialValuesType } from "src/core/types/change-password-type";
import { changePasswordValidationSchema } from "./validation/change-password-validation";

interface IProps {
  changePasswordFormRef: LegacyRef<HTMLDivElement>;
}
function ChangePasswordFormComponent(props: IProps) {
  const { t } = useTranslation();
  const initialValues: InitialValuesType = {
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async () => {},
    validationSchema: changePasswordValidationSchema,
  });
  return (
    <div
      ref={props.changePasswordFormRef}
      className="fixed flex flex-col justify-between mobile:justify-normal items-start mobile:items-center top-0 left-0 inset-y-0 inset-x-0 mx-auto my-auto bg-white shadow-[rgba(0,_0,_0,_0.10)_0px_0px_20px_0px] w-[505px] h-[590px] p-8 laptop:w-[950px] mobile:w-[367px] mobile:h-[520px] tablet:w-[480px] tablet:h-[550x] rounded-2xl"
    >
      <p className="text-right text-zinc-700 text-xl font-arBold leading-[30px] mobile:hidden">
        {t("form.changepassword.component.safety")}
      </p>
      <img
        alt=""
        className="w-[154px] h-8 mobile:mb-3 largeLaptop:hidden desktop:hidden largeDesktop:hidden"
        src="/assets/images/logo.svg"
      />
      <Formik
        initialValues={initialValues}
        validationSchema={changePasswordValidationSchema}
        onSubmit={() => formik.submitForm()}
      >
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <div
            className={`flex flex-col justify-start h-[419.67px] mobile:h-auto`}
          >
            <div
              className={`flex flex-col gap-2  ${
                formik.touched.currentPassword && formik.errors.currentPassword
                  ? "mb-0"
                  : "mb-8 mobile:mb-3"
              }  `}
            >
              <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
                {t("form.changepassword.component.currentpassword")}
              </label>
              <input
                id="currentPassword"
                type="password"
                onChange={(e) => formik.handleChange(e)}
                onBlur={(e) => formik.handleBlur(e)}
                className={`${
                  formik.touched.currentPassword &&
                  formik.errors.currentPassword
                    ? "border-secondary-50 focus:border-secondary-50"
                    : "border-zinc400 focus:border-mint-500"
                } w-[425px] h-[61px] bg-transparent mobile:w-80 mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                placeholder={`${t("changePassword.form.enterPassword")}`}
              ></input>
              {formik.touched.currentPassword &&
                formik.errors.currentPassword && (
                  <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                    {formik.errors.currentPassword}
                  </p>
                )}
            </div>
            <div
              className={`flex flex-col gap-2  ${
                formik.touched.newPassword && formik.errors.newPassword
                  ? "mb-0"
                  : "mb-8 mobile:mb-3"
              }  `}
            >
              <label className="text-zinc400 text-xl leading-[30px] font-arMedium">
                {t("form.changepassword.component.newpassword")}
              </label>
              <input
                id="newPassword"
                type="password"
                onChange={(e) => formik.handleChange(e)}
                onBlur={(e) => formik.handleBlur(e)}
                className={`${
                  formik.touched.newPassword && formik.errors.newPassword
                    ? "border-secondary-50 focus:border-secondary-50"
                    : "border-zinc400 focus:border-mint-500"
                } w-[425px] h-[61px] bg-transparent mobile:w-80  mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                placeholder={`${t("changePassword.form.enterNewPassword")}`}
              ></input>
              {formik.touched.newPassword && formik.errors.newPassword && (
                <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                  {formik.errors.newPassword}
                </p>
              )}
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-zinc400 text-xl leading-[30px] font-arMedium">
                {t("form.changepassword.component.confirmNewPassword")}
              </label>
              <input
                id="confirmNewPassword"
                onChange={(e) => formik.handleChange(e)}
                onBlur={(e) => formik.handleBlur(e)}
                type="password"
                className={`${
                  formik.touched.confirmNewPassword &&
                  formik.errors.confirmNewPassword
                    ? "border-secondary-50 focus:border-secondary-50"
                    : "border-zinc400 focus:border-mint-500"
                } w-[425px] h-[61px] bg-transparent mobile:w-80 mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                placeholder={`${t("changePassword.form.enterConfirmNewPassword")}`}
              ></input>
              {formik.touched.confirmNewPassword &&
                formik.errors.confirmNewPassword && (
                  <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                    {formik.errors.confirmNewPassword}
                  </p>
                )}
            </div>
          </div>
          <button
            type="submit"
            className={`w-[425px] mobile:w-[329px] h-11 p-2 bg-mint-500 rounded-[43px] text-white text-lg font-arMedium ${
              formik.touched.confirmNewPassword &&
              formik.errors.confirmNewPassword
                ? "mobile:mt-0"
                : "mobile:mt-8"
            }`}
          >
            {t("form.changepassword.component.change")}
          </button>
        </Form>
      </Formik>
    </div>
  );
}

export default ChangePasswordFormComponent;
